import { TailSpin } from 'react-loader-spinner'

export default function Spinner({ size }) {

  const sizeSet = size ? size : "80";

  return (
    <div className="w-full h-full flex items-center justify-center">
      <TailSpin
        visible={true}
        height={sizeSet}
        width={sizeSet}
        color="#48e289"
        ariaLabel="tail-spin-loading"
        radius="1"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  )
}